// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/gif;base64,R0lGODlhEAAQAPcAAAAAAIAAAACAAICAAAAAgIAAgACAgMDAwMDcwKbK8P///6Wlpf/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////78KCgpICAgP8AAAD/AP//AAAA//8A/wD//////yH5BAEAAP4ALAAAAAAQABAAAAgpAP0JFHhvoMGDCBMiLKiwocOBDB9KXDixosGIFidizPhwI8eGHj8KDAgAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../node_modules/jquery.fancytree/dist/skin-awesome/vline-rtl.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Fancytree "awesome" skin.
 *
 * DON'T EDIT THE CSS FILE DIRECTLY, since it is automatically generated from
 * the LESS templates.
 */
/* stylelint-disable */
/*******************************************************************************
 * Common Styles for Fancytree Skins.
 *
 * This section is automatically generated from the \`skin-common.less\` template.
 *
 * Copyright (c) 2008-2019, Martin Wendt (https://wwWendt.de)
 * Released under the MIT license
 * https://github.com/mar10/fancytree/wiki/LicenseInfo
 *
 * @version 2.33.0
 * @date 2019-10-29T08:00:07Z
******************************************************************************/
/*------------------------------------------------------------------------------
 * Helpers
 *----------------------------------------------------------------------------*/
.fancytree-helper-hidden {
  display: none;
}
.fancytree-helper-indeterminate-cb {
  color: #777;
}
.fancytree-helper-disabled {
  color: silver;
}
/* Helper to allow spinning loader icon with glyph-, ligature-, and SVG-icons. */
.fancytree-helper-spin {
  -webkit-animation: spin 1000ms infinite linear;
  animation: spin 1000ms infinite linear;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
/*------------------------------------------------------------------------------
 * Container and UL / LI
 *----------------------------------------------------------------------------*/
ul.fancytree-container {
  font-family: tahoma, arial, helvetica;
  font-size: 10pt;
  white-space: nowrap;
  padding: 3px;
  margin: 0;
  background-color: white;
  border: 1px dotted gray;
  min-height: 0%;
  position: relative;
}
ul.fancytree-container ul {
  padding: 0 0 0 10pt;
  margin: 0;
}
ul.fancytree-container ul > li:before {
  content: none;
}
ul.fancytree-container li {
  list-style-image: none;
  list-style-position: outside;
  list-style-type: none;
  -moz-background-clip: border;
  -moz-background-inline-policy: continuous;
  -moz-background-origin: padding;
  background-attachment: scroll;
  background-color: transparent;
  background-position: 0pt 0pt;
  background-repeat: repeat-y;
  background-image: none;
  margin: 0;
}
ul.fancytree-container li.fancytree-lastsib {
  background-image: none;
}
.ui-fancytree-disabled ul.fancytree-container {
  opacity: 0.5;
  background-color: silver;
}
ul.fancytree-connectors.fancytree-container li {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 0 0;
}
ul.fancytree-container li.fancytree-lastsib,
ul.fancytree-no-connector > li {
  background-image: none;
}
li.fancytree-animating {
  position: relative;
}
/*------------------------------------------------------------------------------
 * Common icon definitions
 *----------------------------------------------------------------------------*/
span.fancytree-empty,
span.fancytree-vline,
span.fancytree-expander,
span.fancytree-icon,
span.fancytree-checkbox,
span.fancytree-drag-helper-img,
#fancytree-drop-marker {
  width: 10pt;
  height: 10pt;
  display: inline-block;
  vertical-align: top;
  background-repeat: no-repeat;
  background-position: 0pt 0pt;
}
span.fancytree-icon,
span.fancytree-checkbox,
span.fancytree-expander,
span.fancytree-custom-icon {
  margin-top: 0px;
}
/* Used by icon option: */
span.fancytree-custom-icon {
  width: 10pt;
  height: 10pt;
  display: inline-block;
  margin-left: 3px;
  background-position: 0pt 0pt;
}
/* Used by 'icon' node option: */
img.fancytree-icon {
  width: 10pt;
  height: 10pt;
  margin-left: 3px;
  margin-top: 0px;
  vertical-align: top;
  border-style: none;
}
/*------------------------------------------------------------------------------
 * Expander icon
 *
 * Note: IE6 doesn't correctly evaluate multiples class names,
 *		 so we create combined class names that can be used in the CSS.
 *
 * Prefix: fancytree-exp-
 * 1st character: 'e': expanded, 'c': collapsed, 'n': no children
 * 2nd character (optional): 'd': lazy (Delayed)
 * 3rd character (optional): 'l': Last sibling
 *----------------------------------------------------------------------------*/
span.fancytree-expander {
  cursor: pointer;
}
.fancytree-exp-n span.fancytree-expander,
.fancytree-exp-nl span.fancytree-expander {
  background-image: none;
  cursor: default;
}
.fancytree-connectors .fancytree-exp-n span.fancytree-expander,
.fancytree-connectors .fancytree-exp-nl span.fancytree-expander {
  margin-top: 0;
}
/* Fade out expanders, when container is not hovered or active */
.fancytree-fade-expander span.fancytree-expander {
  transition: opacity 1.5s;
  opacity: 0;
}
.fancytree-fade-expander:hover span.fancytree-expander,
.fancytree-fade-expander.fancytree-treefocus span.fancytree-expander,
.fancytree-fade-expander .fancytree-treefocus span.fancytree-expander,
.fancytree-fade-expander [class*="fancytree-statusnode-"] span.fancytree-expander {
  transition: opacity 0.6s;
  opacity: 1;
}
/*------------------------------------------------------------------------------
 * Checkbox icon
 *----------------------------------------------------------------------------*/
span.fancytree-checkbox {
  margin-left: 3px;
}
.fancytree-unselectable span.fancytree-checkbox {
  opacity: 0.4;
  filter: alpha(opacity=40);
}
.fancytree-container.fancytree-checkbox-auto-hide span.fancytree-checkbox {
  visibility: hidden;
}
.fancytree-container.fancytree-checkbox-auto-hide .fancytree-node:hover span.fancytree-checkbox,
.fancytree-container.fancytree-checkbox-auto-hide tr:hover td span.fancytree-checkbox,
.fancytree-container.fancytree-checkbox-auto-hide .fancytree-node.fancytree-selected span.fancytree-checkbox,
.fancytree-container.fancytree-checkbox-auto-hide tr.fancytree-selected td span.fancytree-checkbox {
  visibility: unset;
}
.fancytree-container.fancytree-checkbox-auto-hide.fancytree-treefocus .fancytree-node.fancytree-active span.fancytree-checkbox,
.fancytree-container.fancytree-checkbox-auto-hide.fancytree-treefocus tr.fancytree-active td span.fancytree-checkbox {
  visibility: unset;
}
/*------------------------------------------------------------------------------
 * Node type icon
 * Note: IE6 doesn't correctly evaluate multiples class names,
 *		 so we create combined class names that can be used in the CSS.
 *
 * Prefix: fancytree-ico-
 * 1st character: 'e': expanded, 'c': collapsed
 * 2nd character (optional): 'f': folder
 *----------------------------------------------------------------------------*/
span.fancytree-icon {
  margin-left: 3px;
}
/* Documents */
/* Folders */
.fancytree-loading span.fancytree-expander,
.fancytree-loading span.fancytree-expander:hover,
.fancytree-statusnode-loading span.fancytree-icon,
.fancytree-statusnode-loading span.fancytree-icon:hover,
span.fancytree-icon.fancytree-icon-loading {
  background-image: none;
}
/* Status node icons */
/*------------------------------------------------------------------------------
 * Node titles and highlighting
 *----------------------------------------------------------------------------*/
span.fancytree-node {
  /* See #117 */
  display: inherit;
  width: 100%;
  margin-top: 1px;
  min-height: 10pt;
}
span.fancytree-title {
  color: #000;
  cursor: pointer;
  display: inline-block;
  vertical-align: top;
  min-height: 10pt;
  padding: 0 3px 0 3px;
  margin: 0px 0 0 3px;
  border: 1px solid transparent;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  -ms-border-radius: 0px;
  -o-border-radius: 0px;
  border-radius: 0px;
}
span.fancytree-node.fancytree-error span.fancytree-title {
  color: red;
}
/*------------------------------------------------------------------------------
 * Drag'n'drop support
 *----------------------------------------------------------------------------*/
/* ext-dnd5: */
span.fancytree-childcounter {
  color: #fff;
  background: #337ab7;
  border: 1px solid gray;
  border-radius: 10px;
  padding: 2px;
  text-align: center;
}
/* ext-dnd: */
div.fancytree-drag-helper span.fancytree-childcounter,
div.fancytree-drag-helper span.fancytree-dnd-modifier {
  display: inline-block;
  color: #fff;
  background: #337ab7;
  border: 1px solid gray;
  min-width: 10px;
  height: 10px;
  line-height: 1;
  vertical-align: baseline;
  border-radius: 10px;
  padding: 2px;
  text-align: center;
  font-size: 9px;
}
div.fancytree-drag-helper span.fancytree-childcounter {
  position: absolute;
  top: -6px;
  right: -6px;
}
div.fancytree-drag-helper span.fancytree-dnd-modifier {
  background: #5cb85c;
  border: none;
  font-weight: bolder;
}
/*** Drop marker icon *********************************************************/
#fancytree-drop-marker {
  width: 20pt;
  position: absolute;
  margin: 0;
}
#fancytree-drop-marker.fancytree-drop-after,
#fancytree-drop-marker.fancytree-drop-before {
  width: 40pt;
}
/*** Source node while dragging ***********************************************/
span.fancytree-drag-source.fancytree-drag-remove {
  opacity: 0.15;
}
/*** Target node while dragging cursor is over it *****************************/
/*------------------------------------------------------------------------------
 * 'rtl' option
 *----------------------------------------------------------------------------*/
.fancytree-container.fancytree-rtl .fancytree-title {
  /*unicode-bidi: bidi-override;*/
  /* optional: reverse title letters */
}
.fancytree-container.fancytree-rtl .fancytree-exp-n span.fancytree-expander,
.fancytree-container.fancytree-rtl .fancytree-exp-nl span.fancytree-expander {
  background-image: none;
}
ul.fancytree-container.fancytree-rtl ul {
  padding: 0 16px 0 0;
}
ul.fancytree-container.fancytree-rtl.fancytree-connectors li {
  background-position: right 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
ul.fancytree-container.fancytree-rtl li.fancytree-lastsib,
ul.fancytree-container.fancytree-rtl.fancytree-no-connector > li {
  background-image: none;
}
/*------------------------------------------------------------------------------
 * 'table' extension
 *----------------------------------------------------------------------------*/
table.fancytree-ext-table {
  font-family: tahoma, arial, helvetica;
  font-size: 10pt;
  border-collapse: collapse;
  /* ext-ariagrid */
}
table.fancytree-ext-table span.fancytree-node {
  display: inline-block;
  box-sizing: border-box;
}
table.fancytree-ext-table td.fancytree-status-merged {
  text-align: center;
  font-style: italic;
  color: silver;
}
table.fancytree-ext-table tr.fancytree-statusnode-error td.fancytree-status-merged {
  color: red;
}
table.fancytree-ext-table.fancytree-ext-ariagrid.fancytree-cell-mode > tbody > tr.fancytree-active > td {
  background-color: #eee;
}
table.fancytree-ext-table.fancytree-ext-ariagrid.fancytree-cell-mode > tbody > tr > td.fancytree-active-cell {
  background-color: #cbe8f6;
}
table.fancytree-ext-table.fancytree-ext-ariagrid.fancytree-cell-mode.fancytree-cell-nav-mode > tbody > tr > td.fancytree-active-cell {
  background-color: #3875d7;
}
/*------------------------------------------------------------------------------
 * 'columnview' extension
 *----------------------------------------------------------------------------*/
table.fancytree-ext-columnview tbody tr td {
  position: relative;
  border: 1px solid gray;
  vertical-align: top;
  overflow: auto;
}
table.fancytree-ext-columnview tbody tr td > ul {
  padding: 0;
}
table.fancytree-ext-columnview tbody tr td > ul li {
  list-style-image: none;
  list-style-position: outside;
  list-style-type: none;
  -moz-background-clip: border;
  -moz-background-inline-policy: continuous;
  -moz-background-origin: padding;
  background-attachment: scroll;
  background-color: transparent;
  background-position: 0pt 0pt;
  background-repeat: repeat-y;
  background-image: none;
  /* no v-lines */
  margin: 0;
}
table.fancytree-ext-columnview span.fancytree-node {
  position: relative;
  /* allow positioning of embedded spans */
  display: inline-block;
}
table.fancytree-ext-columnview span.fancytree-node.fancytree-expanded {
  background-color: #e0e0e0;
}
table.fancytree-ext-columnview span.fancytree-node.fancytree-active {
  background-color: #cbe8f6;
}
table.fancytree-ext-columnview .fancytree-has-children span.fancytree-cv-right {
  position: absolute;
  right: 3px;
}
/*------------------------------------------------------------------------------
 * 'filter' extension
 *----------------------------------------------------------------------------*/
.fancytree-ext-filter-dimm span.fancytree-node span.fancytree-title {
  color: silver;
  font-weight: lighter;
}
.fancytree-ext-filter-dimm tr.fancytree-submatch span.fancytree-title,
.fancytree-ext-filter-dimm span.fancytree-node.fancytree-submatch span.fancytree-title {
  color: black;
  font-weight: normal;
}
.fancytree-ext-filter-dimm tr.fancytree-match span.fancytree-title,
.fancytree-ext-filter-dimm span.fancytree-node.fancytree-match span.fancytree-title {
  color: black;
  font-weight: bold;
}
.fancytree-ext-filter-hide tr.fancytree-hide,
.fancytree-ext-filter-hide span.fancytree-node.fancytree-hide {
  display: none;
}
.fancytree-ext-filter-hide tr.fancytree-submatch span.fancytree-title,
.fancytree-ext-filter-hide span.fancytree-node.fancytree-submatch span.fancytree-title {
  color: silver;
  font-weight: lighter;
}
.fancytree-ext-filter-hide tr.fancytree-match span.fancytree-title,
.fancytree-ext-filter-hide span.fancytree-node.fancytree-match span.fancytree-title {
  color: black;
  font-weight: normal;
}
/* Hide expanders if all child nodes are hidden by filter */
.fancytree-ext-filter-hide-expanders tr.fancytree-match span.fancytree-expander,
.fancytree-ext-filter-hide-expanders span.fancytree-node.fancytree-match span.fancytree-expander {
  visibility: hidden;
}
.fancytree-ext-filter-hide-expanders tr.fancytree-submatch span.fancytree-expander,
.fancytree-ext-filter-hide-expanders span.fancytree-node.fancytree-submatch span.fancytree-expander {
  visibility: visible;
}
.fancytree-ext-childcounter span.fancytree-icon,
.fancytree-ext-filter span.fancytree-icon,
.fancytree-ext-childcounter span.fancytree-custom-icon,
.fancytree-ext-filter span.fancytree-custom-icon {
  position: relative;
}
.fancytree-ext-childcounter span.fancytree-childcounter,
.fancytree-ext-filter span.fancytree-childcounter {
  color: #fff;
  background: #777;
  border: 1px solid gray;
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 10px;
  height: 10px;
  line-height: 1;
  vertical-align: baseline;
  border-radius: 10px;
  padding: 2px;
  text-align: center;
  font-size: 9px;
}
/*------------------------------------------------------------------------------
 * 'wide' extension
 *----------------------------------------------------------------------------*/
ul.fancytree-ext-wide {
  position: relative;
  min-width: 100%;
  z-index: 2;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
ul.fancytree-ext-wide span.fancytree-node > span {
  position: relative;
  z-index: 2;
}
ul.fancytree-ext-wide span.fancytree-node span.fancytree-title {
  position: absolute;
  z-index: 1;
  left: 0px;
  min-width: 100%;
  margin-left: 0;
  margin-right: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
/*------------------------------------------------------------------------------
 * 'fixed' extension
 *----------------------------------------------------------------------------*/
.fancytree-ext-fixed-wrapper .fancytree-ext-fixed-hidden {
  display: none;
}
.fancytree-ext-fixed-wrapper div.fancytree-ext-fixed-scroll-border-bottom {
  border-bottom: 3px solid rgba(0, 0, 0, 0.75);
}
.fancytree-ext-fixed-wrapper div.fancytree-ext-fixed-scroll-border-right {
  border-right: 3px solid rgba(0, 0, 0, 0.75);
}
.fancytree-ext-fixed-wrapper div.fancytree-ext-fixed-wrapper-tl {
  position: absolute;
  overflow: hidden;
  z-index: 3;
  top: 0px;
  left: 0px;
}
.fancytree-ext-fixed-wrapper div.fancytree-ext-fixed-wrapper-tr {
  position: absolute;
  overflow: hidden;
  z-index: 2;
  top: 0px;
}
.fancytree-ext-fixed-wrapper div.fancytree-ext-fixed-wrapper-bl {
  position: absolute;
  overflow: hidden;
  z-index: 2;
  left: 0px;
}
.fancytree-ext-fixed-wrapper div.fancytree-ext-fixed-wrapper-br {
  position: absolute;
  overflow: scroll;
  z-index: 1;
}
/*******************************************************************************
 * Styles specific to this skin.
 *
 * This section is automatically generated from the \`ui-fancytree.less\` template.
 ******************************************************************************/
ul.fancytree-container {
  background-color: black;
}
ul.fancytree-container ul {
  padding: 0.3em 0 0 1em;
  margin: 0;
}
/*******************************************************************************
 * Node titles
 */
span.fancytree-title {
  border: 1px solid transparent;
  border-radius: 0;
}
span.fancytree-focused span.fancytree-title {
  outline: 1px dotted black;
}
span.fancytree-active span.fancytree-title {
  background-color: #D4D4D4;
}
.fancytree-treefocus span.fancytree-active span.fancytree-title {
  color: white;
  background-color: #3875D7;
}
/*******************************************************************************
 * 'table' extension
 */
table.fancytree-ext-table {
  border-collapse: collapse;
}
table.fancytree-ext-table tbody tr.fancytree-focused {
  background-color: #99DEFD;
}
table.fancytree-ext-table tbody tr.fancytree-active {
  background-color: royalblue;
}
/*******************************************************************************
 * 'columnview' extension
 */
table.fancytree-ext-columnview tbody tr td {
  border: 1px solid gray;
}
table.fancytree-ext-columnview span.fancytree-node.fancytree-expanded {
  background-color: #ccc;
}
table.fancytree-ext-columnview span.fancytree-node.fancytree-active {
  background-color: royalblue;
}
`, "",{"version":3,"sources":["webpack://./src/ui.fancytree.css"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF,sBAAsB;AACtB;;;;;;;;;;;8EAW8E;AAC9E;;+EAE+E;AAC/E;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA,gFAAgF;AAChF;EACE,8CAA8C;EAC9C,sCAAsC;AACxC;AACA;EACE;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;AACA;;+EAE+E;AAC/E;EACE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAC5B,yCAAyC;EACzC,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,yDAAupC;EACvpC,wBAAwB;AAC1B;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;;+EAE+E;AAC/E;;;;;;;EAOE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;;;;EAIE,eAAe;AACjB;AACA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;;;;;;;;;+EAU+E;AAC/E;EACE,eAAe;AACjB;AACA;;EAEE,sBAAsB;EACtB,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA,gEAAgE;AAChE;EACE,wBAAwB;EACxB,UAAU;AACZ;AACA;;;;EAIE,wBAAwB;EACxB,UAAU;AACZ;AACA;;+EAE+E;AAC/E;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;;;;EAIE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;;;;;;;;+EAQ+E;AAC/E;EACE,gBAAgB;AAClB;AACA,cAAc;AACd,YAAY;AACZ;;;;;EAKE,sBAAsB;AACxB;AACA,sBAAsB;AACtB;;+EAE+E;AAC/E;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;;+EAE+E;AAC/E,cAAc;AACd;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA,aAAa;AACb;;EAEE,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;AACA,+EAA+E;AAC/E;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;AACA;;EAEE,WAAW;AACb;AACA,+EAA+E;AAC/E;EACE,aAAa;AACf;AACA,+EAA+E;AAC/E;;+EAE+E;AAC/E;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,yDAAyF;AAC3F;AACA;;EAEE,sBAAsB;AACxB;AACA;;+EAE+E;AAC/E;EACE,qCAAqC;EACrC,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAC5B,yCAAyC;EACzC,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;;+EAE+E;AAC/E;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,aAAa;EACb,oBAAoB;AACtB;AACA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;AACA,2DAA2D;AAC3D;;EAEE,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;;+EAE+E;AAC/E;EACE,aAAa;AACf;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;;;;+EAI+E;AAC/E;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,SAAS;AACX;AACA;;EAEE;AACF;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;;EAEE;AACF;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE;AACF;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B","sourcesContent":["/*!\n * Fancytree \"awesome\" skin.\n *\n * DON'T EDIT THE CSS FILE DIRECTLY, since it is automatically generated from\n * the LESS templates.\n */\n/* stylelint-disable */\n/*******************************************************************************\n * Common Styles for Fancytree Skins.\n *\n * This section is automatically generated from the `skin-common.less` template.\n *\n * Copyright (c) 2008-2019, Martin Wendt (https://wwWendt.de)\n * Released under the MIT license\n * https://github.com/mar10/fancytree/wiki/LicenseInfo\n *\n * @version 2.33.0\n * @date 2019-10-29T08:00:07Z\n******************************************************************************/\n/*------------------------------------------------------------------------------\n * Helpers\n *----------------------------------------------------------------------------*/\n.fancytree-helper-hidden {\n  display: none;\n}\n.fancytree-helper-indeterminate-cb {\n  color: #777;\n}\n.fancytree-helper-disabled {\n  color: silver;\n}\n/* Helper to allow spinning loader icon with glyph-, ligature-, and SVG-icons. */\n.fancytree-helper-spin {\n  -webkit-animation: spin 1000ms infinite linear;\n  animation: spin 1000ms infinite linear;\n}\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n/*------------------------------------------------------------------------------\n * Container and UL / LI\n *----------------------------------------------------------------------------*/\nul.fancytree-container {\n  font-family: tahoma, arial, helvetica;\n  font-size: 10pt;\n  white-space: nowrap;\n  padding: 3px;\n  margin: 0;\n  background-color: white;\n  border: 1px dotted gray;\n  min-height: 0%;\n  position: relative;\n}\nul.fancytree-container ul {\n  padding: 0 0 0 10pt;\n  margin: 0;\n}\nul.fancytree-container ul > li:before {\n  content: none;\n}\nul.fancytree-container li {\n  list-style-image: none;\n  list-style-position: outside;\n  list-style-type: none;\n  -moz-background-clip: border;\n  -moz-background-inline-policy: continuous;\n  -moz-background-origin: padding;\n  background-attachment: scroll;\n  background-color: transparent;\n  background-position: 0pt 0pt;\n  background-repeat: repeat-y;\n  background-image: none;\n  margin: 0;\n}\nul.fancytree-container li.fancytree-lastsib {\n  background-image: none;\n}\n.ui-fancytree-disabled ul.fancytree-container {\n  opacity: 0.5;\n  background-color: silver;\n}\nul.fancytree-connectors.fancytree-container li {\n  background-image: url(\"data:image/gif;base64,R0lGODlhEAAQAPcAAAAAAIAAAACAAICAAAAAgIAAgACAgMDAwMDcwKbK8P///6Wlpf/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////78KCgpICAgP8AAAD/AP//AAAA//8A/wD//////yH5BAEAAP4ALAAAAAAQABAAAAgpAP0JFHhvoMGDCBMiLKiwocOBDB9KXDixosGIFidizPhwI8eGHj8KDAgAOw==\");\n  background-position: 0 0;\n}\nul.fancytree-container li.fancytree-lastsib,\nul.fancytree-no-connector > li {\n  background-image: none;\n}\nli.fancytree-animating {\n  position: relative;\n}\n/*------------------------------------------------------------------------------\n * Common icon definitions\n *----------------------------------------------------------------------------*/\nspan.fancytree-empty,\nspan.fancytree-vline,\nspan.fancytree-expander,\nspan.fancytree-icon,\nspan.fancytree-checkbox,\nspan.fancytree-drag-helper-img,\n#fancytree-drop-marker {\n  width: 10pt;\n  height: 10pt;\n  display: inline-block;\n  vertical-align: top;\n  background-repeat: no-repeat;\n  background-position: 0pt 0pt;\n}\nspan.fancytree-icon,\nspan.fancytree-checkbox,\nspan.fancytree-expander,\nspan.fancytree-custom-icon {\n  margin-top: 0px;\n}\n/* Used by icon option: */\nspan.fancytree-custom-icon {\n  width: 10pt;\n  height: 10pt;\n  display: inline-block;\n  margin-left: 3px;\n  background-position: 0pt 0pt;\n}\n/* Used by 'icon' node option: */\nimg.fancytree-icon {\n  width: 10pt;\n  height: 10pt;\n  margin-left: 3px;\n  margin-top: 0px;\n  vertical-align: top;\n  border-style: none;\n}\n/*------------------------------------------------------------------------------\n * Expander icon\n *\n * Note: IE6 doesn't correctly evaluate multiples class names,\n *\t\t so we create combined class names that can be used in the CSS.\n *\n * Prefix: fancytree-exp-\n * 1st character: 'e': expanded, 'c': collapsed, 'n': no children\n * 2nd character (optional): 'd': lazy (Delayed)\n * 3rd character (optional): 'l': Last sibling\n *----------------------------------------------------------------------------*/\nspan.fancytree-expander {\n  cursor: pointer;\n}\n.fancytree-exp-n span.fancytree-expander,\n.fancytree-exp-nl span.fancytree-expander {\n  background-image: none;\n  cursor: default;\n}\n.fancytree-connectors .fancytree-exp-n span.fancytree-expander,\n.fancytree-connectors .fancytree-exp-nl span.fancytree-expander {\n  margin-top: 0;\n}\n/* Fade out expanders, when container is not hovered or active */\n.fancytree-fade-expander span.fancytree-expander {\n  transition: opacity 1.5s;\n  opacity: 0;\n}\n.fancytree-fade-expander:hover span.fancytree-expander,\n.fancytree-fade-expander.fancytree-treefocus span.fancytree-expander,\n.fancytree-fade-expander .fancytree-treefocus span.fancytree-expander,\n.fancytree-fade-expander [class*=\"fancytree-statusnode-\"] span.fancytree-expander {\n  transition: opacity 0.6s;\n  opacity: 1;\n}\n/*------------------------------------------------------------------------------\n * Checkbox icon\n *----------------------------------------------------------------------------*/\nspan.fancytree-checkbox {\n  margin-left: 3px;\n}\n.fancytree-unselectable span.fancytree-checkbox {\n  opacity: 0.4;\n  filter: alpha(opacity=40);\n}\n.fancytree-container.fancytree-checkbox-auto-hide span.fancytree-checkbox {\n  visibility: hidden;\n}\n.fancytree-container.fancytree-checkbox-auto-hide .fancytree-node:hover span.fancytree-checkbox,\n.fancytree-container.fancytree-checkbox-auto-hide tr:hover td span.fancytree-checkbox,\n.fancytree-container.fancytree-checkbox-auto-hide .fancytree-node.fancytree-selected span.fancytree-checkbox,\n.fancytree-container.fancytree-checkbox-auto-hide tr.fancytree-selected td span.fancytree-checkbox {\n  visibility: unset;\n}\n.fancytree-container.fancytree-checkbox-auto-hide.fancytree-treefocus .fancytree-node.fancytree-active span.fancytree-checkbox,\n.fancytree-container.fancytree-checkbox-auto-hide.fancytree-treefocus tr.fancytree-active td span.fancytree-checkbox {\n  visibility: unset;\n}\n/*------------------------------------------------------------------------------\n * Node type icon\n * Note: IE6 doesn't correctly evaluate multiples class names,\n *\t\t so we create combined class names that can be used in the CSS.\n *\n * Prefix: fancytree-ico-\n * 1st character: 'e': expanded, 'c': collapsed\n * 2nd character (optional): 'f': folder\n *----------------------------------------------------------------------------*/\nspan.fancytree-icon {\n  margin-left: 3px;\n}\n/* Documents */\n/* Folders */\n.fancytree-loading span.fancytree-expander,\n.fancytree-loading span.fancytree-expander:hover,\n.fancytree-statusnode-loading span.fancytree-icon,\n.fancytree-statusnode-loading span.fancytree-icon:hover,\nspan.fancytree-icon.fancytree-icon-loading {\n  background-image: none;\n}\n/* Status node icons */\n/*------------------------------------------------------------------------------\n * Node titles and highlighting\n *----------------------------------------------------------------------------*/\nspan.fancytree-node {\n  /* See #117 */\n  display: inherit;\n  width: 100%;\n  margin-top: 1px;\n  min-height: 10pt;\n}\nspan.fancytree-title {\n  color: #000;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: top;\n  min-height: 10pt;\n  padding: 0 3px 0 3px;\n  margin: 0px 0 0 3px;\n  border: 1px solid transparent;\n  -webkit-border-radius: 0px;\n  -moz-border-radius: 0px;\n  -ms-border-radius: 0px;\n  -o-border-radius: 0px;\n  border-radius: 0px;\n}\nspan.fancytree-node.fancytree-error span.fancytree-title {\n  color: red;\n}\n/*------------------------------------------------------------------------------\n * Drag'n'drop support\n *----------------------------------------------------------------------------*/\n/* ext-dnd5: */\nspan.fancytree-childcounter {\n  color: #fff;\n  background: #337ab7;\n  border: 1px solid gray;\n  border-radius: 10px;\n  padding: 2px;\n  text-align: center;\n}\n/* ext-dnd: */\ndiv.fancytree-drag-helper span.fancytree-childcounter,\ndiv.fancytree-drag-helper span.fancytree-dnd-modifier {\n  display: inline-block;\n  color: #fff;\n  background: #337ab7;\n  border: 1px solid gray;\n  min-width: 10px;\n  height: 10px;\n  line-height: 1;\n  vertical-align: baseline;\n  border-radius: 10px;\n  padding: 2px;\n  text-align: center;\n  font-size: 9px;\n}\ndiv.fancytree-drag-helper span.fancytree-childcounter {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n}\ndiv.fancytree-drag-helper span.fancytree-dnd-modifier {\n  background: #5cb85c;\n  border: none;\n  font-weight: bolder;\n}\n/*** Drop marker icon *********************************************************/\n#fancytree-drop-marker {\n  width: 20pt;\n  position: absolute;\n  margin: 0;\n}\n#fancytree-drop-marker.fancytree-drop-after,\n#fancytree-drop-marker.fancytree-drop-before {\n  width: 40pt;\n}\n/*** Source node while dragging ***********************************************/\nspan.fancytree-drag-source.fancytree-drag-remove {\n  opacity: 0.15;\n}\n/*** Target node while dragging cursor is over it *****************************/\n/*------------------------------------------------------------------------------\n * 'rtl' option\n *----------------------------------------------------------------------------*/\n.fancytree-container.fancytree-rtl .fancytree-title {\n  /*unicode-bidi: bidi-override;*/\n  /* optional: reverse title letters */\n}\n.fancytree-container.fancytree-rtl .fancytree-exp-n span.fancytree-expander,\n.fancytree-container.fancytree-rtl .fancytree-exp-nl span.fancytree-expander {\n  background-image: none;\n}\nul.fancytree-container.fancytree-rtl ul {\n  padding: 0 16px 0 0;\n}\nul.fancytree-container.fancytree-rtl.fancytree-connectors li {\n  background-position: right 0;\n  background-image: url(\"../node_modules/jquery.fancytree/dist/skin-awesome/vline-rtl.gif\");\n}\nul.fancytree-container.fancytree-rtl li.fancytree-lastsib,\nul.fancytree-container.fancytree-rtl.fancytree-no-connector > li {\n  background-image: none;\n}\n/*------------------------------------------------------------------------------\n * 'table' extension\n *----------------------------------------------------------------------------*/\ntable.fancytree-ext-table {\n  font-family: tahoma, arial, helvetica;\n  font-size: 10pt;\n  border-collapse: collapse;\n  /* ext-ariagrid */\n}\ntable.fancytree-ext-table span.fancytree-node {\n  display: inline-block;\n  box-sizing: border-box;\n}\ntable.fancytree-ext-table td.fancytree-status-merged {\n  text-align: center;\n  font-style: italic;\n  color: silver;\n}\ntable.fancytree-ext-table tr.fancytree-statusnode-error td.fancytree-status-merged {\n  color: red;\n}\ntable.fancytree-ext-table.fancytree-ext-ariagrid.fancytree-cell-mode > tbody > tr.fancytree-active > td {\n  background-color: #eee;\n}\ntable.fancytree-ext-table.fancytree-ext-ariagrid.fancytree-cell-mode > tbody > tr > td.fancytree-active-cell {\n  background-color: #cbe8f6;\n}\ntable.fancytree-ext-table.fancytree-ext-ariagrid.fancytree-cell-mode.fancytree-cell-nav-mode > tbody > tr > td.fancytree-active-cell {\n  background-color: #3875d7;\n}\n/*------------------------------------------------------------------------------\n * 'columnview' extension\n *----------------------------------------------------------------------------*/\ntable.fancytree-ext-columnview tbody tr td {\n  position: relative;\n  border: 1px solid gray;\n  vertical-align: top;\n  overflow: auto;\n}\ntable.fancytree-ext-columnview tbody tr td > ul {\n  padding: 0;\n}\ntable.fancytree-ext-columnview tbody tr td > ul li {\n  list-style-image: none;\n  list-style-position: outside;\n  list-style-type: none;\n  -moz-background-clip: border;\n  -moz-background-inline-policy: continuous;\n  -moz-background-origin: padding;\n  background-attachment: scroll;\n  background-color: transparent;\n  background-position: 0pt 0pt;\n  background-repeat: repeat-y;\n  background-image: none;\n  /* no v-lines */\n  margin: 0;\n}\ntable.fancytree-ext-columnview span.fancytree-node {\n  position: relative;\n  /* allow positioning of embedded spans */\n  display: inline-block;\n}\ntable.fancytree-ext-columnview span.fancytree-node.fancytree-expanded {\n  background-color: #e0e0e0;\n}\ntable.fancytree-ext-columnview span.fancytree-node.fancytree-active {\n  background-color: #cbe8f6;\n}\ntable.fancytree-ext-columnview .fancytree-has-children span.fancytree-cv-right {\n  position: absolute;\n  right: 3px;\n}\n/*------------------------------------------------------------------------------\n * 'filter' extension\n *----------------------------------------------------------------------------*/\n.fancytree-ext-filter-dimm span.fancytree-node span.fancytree-title {\n  color: silver;\n  font-weight: lighter;\n}\n.fancytree-ext-filter-dimm tr.fancytree-submatch span.fancytree-title,\n.fancytree-ext-filter-dimm span.fancytree-node.fancytree-submatch span.fancytree-title {\n  color: black;\n  font-weight: normal;\n}\n.fancytree-ext-filter-dimm tr.fancytree-match span.fancytree-title,\n.fancytree-ext-filter-dimm span.fancytree-node.fancytree-match span.fancytree-title {\n  color: black;\n  font-weight: bold;\n}\n.fancytree-ext-filter-hide tr.fancytree-hide,\n.fancytree-ext-filter-hide span.fancytree-node.fancytree-hide {\n  display: none;\n}\n.fancytree-ext-filter-hide tr.fancytree-submatch span.fancytree-title,\n.fancytree-ext-filter-hide span.fancytree-node.fancytree-submatch span.fancytree-title {\n  color: silver;\n  font-weight: lighter;\n}\n.fancytree-ext-filter-hide tr.fancytree-match span.fancytree-title,\n.fancytree-ext-filter-hide span.fancytree-node.fancytree-match span.fancytree-title {\n  color: black;\n  font-weight: normal;\n}\n/* Hide expanders if all child nodes are hidden by filter */\n.fancytree-ext-filter-hide-expanders tr.fancytree-match span.fancytree-expander,\n.fancytree-ext-filter-hide-expanders span.fancytree-node.fancytree-match span.fancytree-expander {\n  visibility: hidden;\n}\n.fancytree-ext-filter-hide-expanders tr.fancytree-submatch span.fancytree-expander,\n.fancytree-ext-filter-hide-expanders span.fancytree-node.fancytree-submatch span.fancytree-expander {\n  visibility: visible;\n}\n.fancytree-ext-childcounter span.fancytree-icon,\n.fancytree-ext-filter span.fancytree-icon,\n.fancytree-ext-childcounter span.fancytree-custom-icon,\n.fancytree-ext-filter span.fancytree-custom-icon {\n  position: relative;\n}\n.fancytree-ext-childcounter span.fancytree-childcounter,\n.fancytree-ext-filter span.fancytree-childcounter {\n  color: #fff;\n  background: #777;\n  border: 1px solid gray;\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  min-width: 10px;\n  height: 10px;\n  line-height: 1;\n  vertical-align: baseline;\n  border-radius: 10px;\n  padding: 2px;\n  text-align: center;\n  font-size: 9px;\n}\n/*------------------------------------------------------------------------------\n * 'wide' extension\n *----------------------------------------------------------------------------*/\nul.fancytree-ext-wide {\n  position: relative;\n  min-width: 100%;\n  z-index: 2;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\nul.fancytree-ext-wide span.fancytree-node > span {\n  position: relative;\n  z-index: 2;\n}\nul.fancytree-ext-wide span.fancytree-node span.fancytree-title {\n  position: absolute;\n  z-index: 1;\n  left: 0px;\n  min-width: 100%;\n  margin-left: 0;\n  margin-right: 0;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n/*------------------------------------------------------------------------------\n * 'fixed' extension\n *----------------------------------------------------------------------------*/\n.fancytree-ext-fixed-wrapper .fancytree-ext-fixed-hidden {\n  display: none;\n}\n.fancytree-ext-fixed-wrapper div.fancytree-ext-fixed-scroll-border-bottom {\n  border-bottom: 3px solid rgba(0, 0, 0, 0.75);\n}\n.fancytree-ext-fixed-wrapper div.fancytree-ext-fixed-scroll-border-right {\n  border-right: 3px solid rgba(0, 0, 0, 0.75);\n}\n.fancytree-ext-fixed-wrapper div.fancytree-ext-fixed-wrapper-tl {\n  position: absolute;\n  overflow: hidden;\n  z-index: 3;\n  top: 0px;\n  left: 0px;\n}\n.fancytree-ext-fixed-wrapper div.fancytree-ext-fixed-wrapper-tr {\n  position: absolute;\n  overflow: hidden;\n  z-index: 2;\n  top: 0px;\n}\n.fancytree-ext-fixed-wrapper div.fancytree-ext-fixed-wrapper-bl {\n  position: absolute;\n  overflow: hidden;\n  z-index: 2;\n  left: 0px;\n}\n.fancytree-ext-fixed-wrapper div.fancytree-ext-fixed-wrapper-br {\n  position: absolute;\n  overflow: scroll;\n  z-index: 1;\n}\n/*******************************************************************************\n * Styles specific to this skin.\n *\n * This section is automatically generated from the `ui-fancytree.less` template.\n ******************************************************************************/\nul.fancytree-container {\n  background-color: black;\n}\nul.fancytree-container ul {\n  padding: 0.3em 0 0 1em;\n  margin: 0;\n}\n/*******************************************************************************\n * Node titles\n */\nspan.fancytree-title {\n  border: 1px solid transparent;\n  border-radius: 0;\n}\nspan.fancytree-focused span.fancytree-title {\n  outline: 1px dotted black;\n}\nspan.fancytree-active span.fancytree-title {\n  background-color: #D4D4D4;\n}\n.fancytree-treefocus span.fancytree-active span.fancytree-title {\n  color: white;\n  background-color: #3875D7;\n}\n/*******************************************************************************\n * 'table' extension\n */\ntable.fancytree-ext-table {\n  border-collapse: collapse;\n}\ntable.fancytree-ext-table tbody tr.fancytree-focused {\n  background-color: #99DEFD;\n}\ntable.fancytree-ext-table tbody tr.fancytree-active {\n  background-color: royalblue;\n}\n/*******************************************************************************\n * 'columnview' extension\n */\ntable.fancytree-ext-columnview tbody tr td {\n  border: 1px solid gray;\n}\ntable.fancytree-ext-columnview span.fancytree-node.fancytree-expanded {\n  background-color: #ccc;\n}\ntable.fancytree-ext-columnview span.fancytree-node.fancytree-active {\n  background-color: royalblue;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
